module.exports = __webpack_public_path__ + "media/categories/2041-63043a99.svg";